import { useEffect, useState } from "react";
import { freshness } from "@/lib/freshness";

/**
 * "Reviewed 2026-06-02" — and, once it is far enough back to matter, how long ago.
 *
 * The age is filled in after mount rather than during SSR. These pages are cached, so a
 * server-rendered age would be the age when the page was cached, not when it was read —
 * and a date that says "3 months ago" for a year is worse than one that says nothing.
 */
export function ReviewedLine({
  iso,
  label = "Reviewed",
  suffix,
  className = "text-xs text-muted-foreground",
}: {
  iso: string;
  label?: string;
  suffix?: string;
  className?: string;
}) {
  const [age, setAge] = useState<string | null>(null);

  useEffect(() => {
    const f = freshness(iso);
    setAge(f.stale ? f.age : null);
  }, [iso]);

  return (
    <p className={className}>
      {label} <time dateTime={iso}>{longDate(iso)}</time>
      {age ? ` (${age})` : ""}
      {suffix ? ` · ${suffix}` : ""}
    </p>
  );
}

/** "2026-06-02" -> "June 2, 2026", in UTC so the server and the browser agree. */
function longDate(iso: string): string {
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}
